import DropDown from "./components/Dropdown.vue";
// import DataGrid from "./pages/WarehouseItems.vue";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("drop-down", DropDown);
    // Vue.component("data-grid", DataGrid);
  },
};

export default GlobalComponents;
